import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import DatePicker from '../../../../../LaridaeApp/datepicker/container/DatePicker'
import { INTERVALO_CORTO } from '../../../../../../config/settings'
import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesRechazadosEnCaladoActions'
import { TablaCamionesRechazadosEnCaladoView } from '../components/TablaCamionesRechazadosEnCaladoView'

function TablaCamionesRechazadosEnCalado (props) {
  const { actualizarDatosParaMuiTable, roles } = props

  useEffect(() => {
    const rol = roles.filter(roles => roles === 'EXPORTADOR' || roles === 'CARGADOR')
    actualizarDatosParaMuiTable(new Date(), new Date(), rol)
  }, [actualizarDatosParaMuiTable, roles])

  const actualizarFechas = (fechaD, fechaH) => {
    const rol = roles.filter(roles => roles === 'EXPORTADOR' || roles === 'CARGADOR')
    props.actualizarDatosParaMuiTable(fechaD, fechaH, rol)
  }

  return (
    <div>
      <div className='container-entre-fechas'>
        <DatePicker
          selectRange
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>
      <TablaCamionesRechazadosEnCaladoView />
      <ToastContainer autoClose={INTERVALO_CORTO} />
    </div>
  )
}

const mapStateToProps = state => {
  return {
    roles: state.auth.roles
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(TablaCamionesRechazadosEnCalado)
